import { useCallback } from "react";
export const useCurrentStepValidation = (aggregatedValidation) => {
  const STEP_VALIDATION_MAP = {
    // Detail steps (numeric)
    1: "Step 1",

    // Document tabs (string-based)
    "Salary Details": "Salary Details",
    Iqama: "Iqama",
    "National ID": "National ID",
    Account: "Account",
    "Health Insurance": "Health Insurance",
    "Health Card": "Health Card",
    Passport: "Passport",
    Visa: "Visa",
    Contract: "Contract",
    "Driving License": "Driving License",
    Subscription: "Subscription",
  };

  const checkCurrentStepValidation = useCallback(
    (currentStep) => {
      // Handle null/undefined cases
      if (!currentStep || !aggregatedValidation) {
        return false;
      }

      // Get validation step name from mapping
      const validationStepName = STEP_VALIDATION_MAP[currentStep];

      if (!validationStepName) {
        console.warn(`No validation mapping found for step: ${currentStep}`);
        return false;
      }

      // Check if current step has validation errors
      return aggregatedValidation.shouldDisableStep(validationStepName);
    },
    [aggregatedValidation]
  );

  const getCurrentStepErrors = useCallback(
    (currentStep) => {
      if (!currentStep || !aggregatedValidation) {
        return [];
      }

      const validationStepName = STEP_VALIDATION_MAP[currentStep];

      if (!validationStepName) {
        return [];
      }

      return aggregatedValidation.getErrorsForStep(validationStepName);
    },
    [aggregatedValidation]
  );

  const isCurrentStepSearching = useCallback(
    (currentStep) => {
      if (!currentStep || !aggregatedValidation) {
        return false;
      }

      const validationStepName = STEP_VALIDATION_MAP[currentStep];

      if (!validationStepName) {
        return false;
      }

      return aggregatedValidation.isStepSearching(validationStepName);
    },
    [aggregatedValidation]
  );

  return {
    checkCurrentStepValidation,
    getCurrentStepErrors,
    isCurrentStepSearching,
  };
};
